import { Component, inject, input, output, signal } from '@angular/core';
import {
  AccessGroupSharedDiscountSearchEvent,
  AccessGroupSharedDiscountService,
  IAccessGroupSharedDiscountSearchResultItem,
} from '../../services/access-group-shared-discount.service';
import { map, Observable, of } from 'rxjs';
import { PagedResult } from '../../models/paging';
import { TypeAheadSelector2Component } from '../type-ahead-selector2/type-ahead-selector2.component';

@Component({
  selector: 'adm-admin-shared-discount-type-ahead',
  imports: [TypeAheadSelector2Component],
  templateUrl: './adm-shared-discount-type-ahead.component.html',
  styleUrl: './adm-shared-discount-type-ahead.component.scss',
})
export class AdminSharedDiscountTypeAheadComponent {
  private sharedDiscountService = inject(AccessGroupSharedDiscountService);
  itemSelected = output<IAccessGroupSharedDiscountSearchResultItem | null>();
  initialId = input<string>();
  resetTrigger = input<{ reset: boolean }>();
  discountsFetched = output<IAccessGroupSharedDiscountSearchResultItem[] | null>();
  clearTypeAhead = output();

  fetchDiscounts = (term: string): Observable<IAccessGroupSharedDiscountSearchResultItem[]> => {
    const searchEvent: AccessGroupSharedDiscountSearchEvent = {
      paging: { pageIndex: 0, pageSize: 1000, length: 0 },
      sorting: null,
      query: term.length > 0 ? term : null,
    };

    return this.sharedDiscountService.getSharedDiscounts(searchEvent).pipe(
      map((result: PagedResult<IAccessGroupSharedDiscountSearchResultItem>) => {
        this.discountsFetched.emit(result.items);
        return result.items;
      })
    );
  };

  fetchDiscountById = (id: string): Observable<IAccessGroupSharedDiscountSearchResultItem | null> => {
    const searchEvent = <AccessGroupSharedDiscountSearchEvent>{
      paging: { pageIndex: 0, pageSize: 1000, length: 0 },
      sorting: null,
    };

    return this.sharedDiscountService.getSharedDiscounts(searchEvent).pipe(
      map((result: PagedResult<IAccessGroupSharedDiscountSearchResultItem>) => {
        const discount = result.items.find(x => x.identifier === id);
        return discount ?? null;
      })
    );
  };

  discountSelected = (discount?: IAccessGroupSharedDiscountSearchResultItem | null) => {
    this.itemSelected.emit(discount ? discount : null);
  };
}
